
export class ConfigurationModel {
    changePassword(newPassword: string, oldPassword?: string) {
        return new Promise((resolve, reject) => {
            setTimeout(() => resolve(true), 300);
        })
    }
}
